interface SEODataProps {
  organizationSchema?: Record<string, unknown>;
  websiteSchema?: Record<string, unknown>;
  webpageSchema?: Record<string, unknown>;
  faqSchema?: Record<string, unknown>;
}

export default function StructuredData({ organizationSchema, websiteSchema, webpageSchema, faqSchema }: SEODataProps) {
  const schemas: Record<string, unknown>[] = [];

  if (organizationSchema) schemas.push(organizationSchema);
  if (websiteSchema) schemas.push(websiteSchema);
  if (webpageSchema) schemas.push(webpageSchema);
  if (faqSchema) schemas.push(faqSchema);

  if (schemas.length === 0) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas.length === 1 ? schemas[0] : schemas) }}
    />
  );
}